export default __webpack_public_path__ + "static/media/icons_X.404d30d5.png";